import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/svg/white-plus.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-0cc57598")

_pushScopeId("data-v-0cc57598")
const _hoisted_1 = { class: "contain-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "Add To Party", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "ion-padding add-to-party" }, {
    default: _withId(() => [
      _createVNode("h3", null, _toDisplayString(_ctx.title), 1),
      _createVNode(_component_ion_grid, null, {
        default: _withId(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-start" }, {
            default: _withId(() => [
              _createVNode("img", {
                class: "logo",
                src: 'https://suppliers.partyplace.je/storage/' + _ctx.image
              }, null, 8, ["src"]),
              _createVNode(_component_ion_title, null, {
                default: _withId(() => [
                  _createVNode("h2", null, _toDisplayString(_ctx.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createVNode("textarea", {
        class: "ion-padding",
        placeholder: "Add your requirements and requests for the party here...",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.notes = $event))
      }, null, 512), [
        [_vModelText, _ctx.notes]
      ]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_ion_button, {
          color: "success",
          size: "large",
          onClick: _ctx.addToPartyBag,
          disabled: _ctx.notes === ''
        }, {
          default: _withId(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }))
})